import { QueryClient } from '@tanstack/react-query';
import { ReportPeriodDto, UserRegistrationPeriod, UserReportingPeriodState } from '../api/generated/data-contracts';
import { CURRENT_PERIOD } from '../constants/queryKeys';

export const updateReportPeriod = (
    updatedUserRegistrationPeriods: UserRegistrationPeriod[],
    state: UserReportingPeriodState,
    startDate: Date,
    queryClient: QueryClient,
) => {
    const currentPeriod = queryClient.getQueryData([CURRENT_PERIOD, startDate.getISOStringMidnight()]);

    if (currentPeriod) {
        queryClient.setQueryData<ReportPeriodDto>([CURRENT_PERIOD, startDate.getISOStringMidnight()], prevState => {
            return {
                ...prevState,
                userRegistrationPeriods: updatedUserRegistrationPeriods,
                reportPeriod: {
                    ...prevState.reportPeriod,
                    state: state,
                },
            };
        });
    }
};
